import React from "react";
import { WarningIcon } from "../../../../assets/icons/svgicons";
import ErrorText from "../ErrorText/ErrorText";
import styles from "./Input.module.scss";

const InputFormik = ({
  name,
  className,
  iconClassName,
  variant,
  type,
  label,
  onFocus,
  onBlur,
  onChange,
  value,
  formik,
  maxLength,
  icon,
  children,
  placeholder,
  blackError,
  ...rest
}) => {
  return (
    <div
      className={`${styles.input} ${className || ""}`}
      data-variant={variant}
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className={`${styles.input_inner} ${icon ? styles.icon_input : ""}`}>
        {rest.multiline ? (
          <textarea
            {...rest}
            name={name}
            id={name}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            rows={rest.rows || 2}
          />
        ) : (
          <input
            {...rest}
            name={name}
            id={name}
            maxLength={maxLength}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            type={type || "text"}
            placeholder={placeholder}
          />
        )}
        {!icon && formik?.touched[name] && formik?.errors[name] && (
          <span className={`${styles.icon} ${styles.warning_icon}`}>
            <WarningIcon />
          </span>
        )}
        {icon && (
          <span
            className={`iconright ${styles.icon} ${formik?.touched[name] && formik?.errors[name]
              ? styles.warning_icon
              : ""
              } ${iconClassName || ""}`}
          >
            {/* {formik?.touched[name] && formik?.errors[name] ? icon :""} */}
            {icon}
          </span>
        )}
      </div>
      {formik?.touched[name] && formik?.errors[name] && (
        <ErrorText blackError={blackError}>{formik?.errors[name]}</ErrorText>
      )}
      {children}
    </div>
  );
};
export default InputFormik;
